import { AssignTree } from 'src/types'

export type FormModalTreeNodeProps = Omit<
  AssignTree,
  'user_tree' | 'policies' | 'childrens'
> & {
  parent_name: string
}

export const initialValues = {} as FormModalTreeNodeProps
